import React from "react";
import { ICONS } from "../utils/assets";
import Button from "./form/Button";

const OrganisationCard = ({
  name,
  logo,
  accountId,
  status,
  statusDescription,
  completed,
}) => {
  const getButtonVariant = (status) => {
    switch (status) {
      case 1:
        return "disabled";
      case 2:
        return "danger-primary";
      case 3:
        return "success";
      default:
        return "disabled";
    }
  };
  const getButtonIcon = (status) => {
    switch (status) {
      case 1:
        return ICONS.LOAD_ICON;
      case 2:
        return null;
      case 3:
        return ICONS.CHECK_ICON;
      default:
        return null;
    }
  };

  return (
    <div
      className={`dashboard-organisation__item ${
        status === 2 ? "dashboard-organisation__item--danger" : ""
      }`}
    >
      <div className="dashboard-organisation__header">
        <div className="logo-box">
          <img className="logo-box__image" src={logo} alt={name + " logo"} />
        </div>
        <div>
          <p className="small semibold text-neutral-950">{name}</p>
          <p className="small text-neutral-950">{accountId}</p>
        </div>
      </div>
      {!completed && (
        <Button
          variant={getButtonVariant(status)}
          icon={getButtonIcon(status)}
          iconLeft
          compact
          // onClick={() => navigate("/dashboard-line/1")}
        >
          {statusDescription}
        </Button>
      )}
    </div>
  );
};

export default OrganisationCard;
